/**
 * Bill Payments saga functions
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import Actions from './actions';
import Constants from '../../constants';
import UserApi from '../../Lib/Api/user';
import { handleError } from '../../Lib/Utils/saga-utils';

const { BillPayments } = Constants;
const {
  getBillPaymentsError,
  getBillPaymentsSuccess,
  getBillPaymentError,
  getBillPaymentSuccess,
} = Actions;

/**
 * Fetches bill payments and dispatches success or error
 *
 * @param {object} action:
 * {
 *   @property {string} userId: the user id
 *   @property {object} params: query params
 * }
 */
export function* getBillPayments({ userId, params }) {
  try {
    const response = yield call(UserApi.getBillPayments, userId, params);
    yield put(getBillPaymentsSuccess(response));
  } catch (err) {
    yield handleError(getBillPaymentsError, err);
  }
}

/**
 * Fetches bill payments and dispatches success or error
 *
 * @param {object} action:
 * {
 *   @property {string} userId: the user id
 *   @property {object} params: query params
 * }
 */
export function* getBillPayment({ userId, billPaymentId }) {
  try {
    const response = yield call(UserApi.getBillPayment, userId, billPaymentId);
    yield put(getBillPaymentSuccess(response));
  } catch (err) {
    yield handleError(getBillPaymentError, err);
  }
}

/**
 * Gets the bill payments response from the latest request fired
 */
function* billPaymentSaga() {
  yield takeLatest(BillPayments.GET_BILL_PAYMENTS, getBillPayments);
  yield takeLatest(BillPayments.GET_BILL_PAYMENT, getBillPayment);
}

export default billPaymentSaga;
